/* Real document navigation, with the same 1180 / 260 / 1220 ms choreography as the approved study.
   This small head script restores the texture before the destination's first paint. */
(() => {
  'use strict';
  const KEY='alda:material-dive:v1', root=document.documentElement;
  const reduce=matchMedia('(prefers-reduced-motion: reduce)');
  const easing='cubic-bezier(.37,0,.63,1)';
  let active=null;
  // Wheel and touch scrolling are blocked only while a dive runs: no blocking listener the rest of the time.
  let blocking=false;
  function blockScroll(event){if(active)event.preventDefault();}
  function block(on){if(on===blocking)return;blocking=on;const m=on?'addEventListener':'removeEventListener';window[m]('wheel',blockScroll,{passive:false});window[m]('touchmove',blockScroll,{passive:false});}
  const normalPath=path=>path.replace(/\/$/,'')||'/';
  const samePage=(a,b)=>normalPath(a.pathname)===normalPath(b.pathname)&&a.search===b.search;
  const supported=()=>!reduce.matches&&typeof Element.prototype.animate==='function';
  function clearRecord(){try{sessionStorage.removeItem(KEY);}catch{}}
  function saveRecord(data){try{sessionStorage.setItem(KEY,JSON.stringify(data));return true;}catch{return false;}}
  function makeLayer(data){
    const layer=document.createElement('div');layer.className='alda-material-dive';layer.setAttribute('aria-hidden','true');
    const image=document.createElement('div');image.className='alda-material-dive-images';
    const textures=data.textures||[{image:data.image}];
    image.classList.toggle('is-split',textures.length===2);
    const photos=textures.map(texture=>{
      const frame=document.createElement('span'), photo=new Image();photo.src=texture.image;photo.alt='';photo.decoding='sync';
      if(texture.scale){photo.style.transform=`scale(${texture.scale})`;photo.style.transformOrigin=texture.origin||'50% 50%';}
      frame.append(photo);image.append(frame);return photo;
    });
    const shade=document.createElement('div');shade.className='alda-material-dive-shade';
    const title=document.createElement('p');title.className='alda-material-dive-title';
    const label=document.createElement('small');label.textContent='EXPLORE THE MATERIAL';
    title.append(label,document.createTextNode(data.name));layer.append(image,shade,title);
    root.append(layer);
    return {layer,image,title,photos};
  }
  function animate(run,el,frames,duration,delay=0){
    if(!el)return Promise.resolve();
    const animation=el.animate(frames,{duration,delay,easing,fill:'both'});
    run.animations.push(animation);
    return animation.finished.catch(()=>{});
  }
  function lock(run){
    root.classList.add('md-active');block(true);
    run.bodyInert=document.body.inert;document.body.inert=true;
    window.aldaLenis?.stop();
  }
  function cleanup(run=active){
    if(!run)return;
    clearTimeout(run.watchdog);
    run.animations.forEach(a=>a.cancel());run.layer.remove();
    root.classList.remove('md-active','md-arriving');
    if(document.body&&run.bodyInert!==undefined)document.body.inert=run.bodyInert;
    if(active===run)active=null;
    if(!active)block(false);
    if(!document.body?.classList.contains('ac-open')&&!root.classList.contains('mn-open'))window.aldaLenis?.start();
  }
  function focusHeading(){
    const heading=document.querySelector('main h1');
    if(!heading)return;
    const old=heading.getAttribute('tabindex');heading.tabIndex=-1;heading.classList.add('md-arrival-heading');heading.focus({preventScroll:true});
    heading.addEventListener('blur',()=>{heading.classList.remove('md-arrival-heading');if(old===null)heading.removeAttribute('tabindex');else heading.setAttribute('tabindex',old);},{once:true});
  }
  function navigate(run){
    if(active!==run||run.navigating)return;
    run.navigating=true;
    saveRecord({...run.data,created:Date.now()});
    // An interrupted resize/reduced-motion change still leaves an opaque cover until navigation.
    run.animations.forEach(a=>a.cancel());
    Object.assign(run.layer.style,{inset:'0',width:'auto',height:'auto',borderRadius:'0',transform:'none'});
    run.image.style.transform='none';run.title.style.opacity='1';
    run.watchdog=setTimeout(()=>{clearRecord();cleanup(run);run.link?.focus({preventScroll:true});},12000);
    location.assign(run.data.to);
  }
  function depart(link){
    const art=link.querySelector('.v2-mat-art'), image=art?.querySelector('img'), photos=[...art?.querySelectorAll('img')||[]];
    if(!photos.length||photos.some(photo=>!photo.complete||!photo.naturalWidth))return false;
    const url=new URL(link.href,location.href), imgURL=new URL(image.currentSrc||image.src,location.href);
    if(url.origin!==location.origin||imgURL.origin!==location.origin||samePage(url,location))return false;
    const textures=photos.map(photo=>({image:new URL(photo.currentSrc||photo.src,location.href).pathname,
      scale:Number(photo.dataset.textureScale)||1,origin:photo.dataset.textureOrigin||'50% 50%'}));
    if(photos.some(photo=>new URL(photo.currentSrc||photo.src,location.href).origin!==location.origin))return false;
    const data={to:url.pathname+url.search,image:imgURL.pathname,textures,name:link.querySelector('.v2-mat-n').textContent.trim(),created:Date.now()};
    // If storage is unavailable, the original link is still a normal navigation.
    if(!saveRecord(data))return false;
    const box=art.getBoundingClientRect(), style=getComputedStyle(art), imageStyle=getComputedStyle(art.querySelector('.v2-mat-split')||image);
    const run={...makeLayer(data),data,link,mode:'exit',animations:[]};active=run;
    Object.assign(run.layer.style,{inset:'auto',left:box.x+'px',top:box.y+'px',width:box.width+'px',height:box.height+'px',borderRadius:style.borderRadius});
    run.image.style.transform=imageStyle.transform;
    const origin=imageStyle.transformOrigin.split(' ').map(parseFloat);
    run.image.style.transformOrigin=`${origin[0]/box.width*100}% ${origin[1]/box.height*100}%`;
    run.title.style.opacity='0';
    lock(run);
    // All measurements are captured once, before motion begins.
    Promise.all([
      animate(run,document.querySelector('main'),[{opacity:1},{opacity:.5}],1100),
      animate(run,run.title,[{opacity:0,transform:'translateY(16px)'},{opacity:1,transform:'translateY(0)'}],700,350),
      animate(run,run.image,[{transform:imageStyle.transform},{transform:'none'}],1180),
      animate(run,run.layer,[{left:box.x+'px',top:box.y+'px',width:box.width+'px',height:box.height+'px',borderRadius:style.borderRadius},{left:'0px',top:'0px',width:innerWidth+'px',height:innerHeight+'px',borderRadius:'0px'}],1180)
    ]).then(async()=>{
      if(active!==run||run.navigating)return;
      await animate(run,run.layer,[{opacity:1},{opacity:1}],260);
      navigate(run);
    }).catch(()=>navigate(run));
    return true;
  }
  function bounded(promises,ms){
    return new Promise(resolve=>{
      const timer=setTimeout(resolve,ms);
      Promise.allSettled(promises).then(()=>{clearTimeout(timer);resolve();});
    });
  }
  async function arrive(run){
    if(active!==run)return;
    lock(run);
    const main=document.querySelector('main');
    const visibleImages=[...document.querySelectorAll('main img')].filter(img=>!img.closest('[hidden]')&&img.getBoundingClientRect().top<innerHeight).slice(0,6);
    visibleImages.forEach(img=>img.loading='eager');
    await bounded([document.fonts.ready,...run.photos.map(img=>img.decode()),...visibleImages.map(img=>img.decode())],800);
    await new Promise(resolve=>requestAnimationFrame(()=>requestAnimationFrame(resolve)));
    if(active!==run)return;
    root.classList.remove('md-arriving');
    if(!supported()){cleanup(run);focusHeading();return;}
    await Promise.all([
      animate(run,main,[{transform:'translateY(18px)'},{transform:'translateY(0)'}],1220),
      animate(run,run.title,[{opacity:1},{opacity:0}],480),
      animate(run,run.layer,[{transform:'translateY(0)'},{transform:'translateY(-102%)'}],1120)
    ]);
    if(active===run){cleanup(run);focusHeading();}
  }
  // Consume once: direct visits, reloads and Back/Forward never replay a stored arrival.
  let pending;
  try{pending=JSON.parse(sessionStorage.getItem(KEY)||'null');}catch{}
  clearRecord();
  const navigationType=performance.getEntriesByType('navigation')[0]?.type;
  if(pending&&supported()&&navigationType!=='back_forward'&&navigationType!=='reload'){
    try{
      const url=new URL(pending.to,location.origin), image=new URL(pending.image,location.origin);
      const texturesValid=!pending.textures||(Array.isArray(pending.textures)&&pending.textures.length>0&&pending.textures.length<=2&&pending.textures.every(t=>{
        const source=new URL(t.image,location.origin);return source.origin===location.origin&&source.pathname.startsWith('https://static.aldaindia.com/alda-assets/')&&[1,1.8].includes(t.scale)&&['50% 50%','20% 62%'].includes(t.origin);
      }));
      if(texturesValid&&url.origin===location.origin&&samePage(url,location)&&image.origin===location.origin&&image.pathname.startsWith('https://static.aldaindia.com/alda-assets/')&&typeof pending.name==='string'&&pending.name.length<80&&Date.now()-pending.created<30000){
        root.classList.add('md-arriving');
        active={...makeLayer(pending),data:pending,mode:'enter',animations:[]};block(true);
        const run=active;run.watchdog=setTimeout(()=>cleanup(run),7000);
        document.addEventListener('DOMContentLoaded',()=>arrive(run).catch(()=>cleanup(run)),{once:true});
      }
    }catch{root.classList.remove('md-arriving');}
  }
  document.addEventListener('click',event=>{
    const link=event.target.closest?.('.v2-materials-intro a.v2-mat');
    if(!link||event.defaultPrevented||event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey||link.hasAttribute('download')||(link.target&&link.target!=='_self')||!supported())return;
    if(active){event.preventDefault();return;}
    // Setup is synchronous; prevent navigation only when the enhancement actually started.
    try{if(depart(link))event.preventDefault();}catch{clearRecord();cleanup();}
  });
  document.addEventListener('keydown',event=>{
    if(!active)return;
    if(event.key==='Escape'){
      const run=active;
      if(run.mode==='exit'&&!run.navigating){clearRecord();cleanup(run);run.link.focus({preventScroll:true});}
      else if(run.mode==='enter'){cleanup(run);focusHeading();}
      event.preventDefault();
    }else if(['Tab',' ','PageDown','PageUp','Home','End','ArrowDown','ArrowUp'].includes(event.key))event.preventDefault();
  },true);
  addEventListener('pageshow',event=>{if(event.persisted){clearRecord();cleanup();}});
  addEventListener('resize',()=>{if(active?.mode==='exit')navigate(active);else if(active?.mode==='enter')cleanup();});
  reduce.addEventListener('change',()=>{if(!reduce.matches||!active)return;if(active.mode==='exit')navigate(active);else{cleanup();focusHeading();}});
  // A same-origin hint only; no hidden copy of the listing, cart or page scripts is run.
  const prefetched=new Set();
  function prefetch(event){
    const link=event.target.closest?.('.v2-materials-intro a.v2-mat');
    if(!link||prefetched.has(link.href)||navigator.connection?.saveData)return;
    const url=new URL(link.href);if(url.origin!==location.origin)return;
    prefetched.add(link.href);const hint=document.createElement('link');hint.rel='prefetch';hint.as='document';hint.href=link.href;document.head.append(hint);
  }
  document.addEventListener('pointerover',prefetch,{passive:true});document.addEventListener('focusin',prefetch);
})();
